import { Link } from "react-router-dom";
import { Username, Avatar } from "./UserBadge";
import { format, formatDistanceToNow } from "date-fns";
import { ro } from "date-fns/locale";
import { ArrowRight, Clock } from "lucide-react";

export default function LastPostMember({ user, time, topicTitle, topicLink, customColor, stats }) {
  const u = typeof user === "string" ? { username: user } : user;

  if (!u || !u.username) {
    return (
      <div className="relative pl-3 flex flex-col justify-center min-w-0">
        <span className="text-zinc-600 font-mono text-[11px] italic">Nicio activitate recentă</span>
        {stats && (
          <div className="mt-1.5 pt-1 border-t border-white/5 relative z-20">
            {stats}
          </div>
        )}
      </div>
    );
  }

  const accentColor = customColor || u.group_color || "var(--tf-primary)";

  let formattedDate = "recent";
  let relativeTime = "";
  if (time) {
    try {
      const d = new Date(time);
      formattedDate = format(d, 'dd MMM yyyy, HH:mm');
      relativeTime = formatDistanceToNow(d, { addSuffix: true, locale: ro });
    } catch {
      formattedDate = "recent";
    }
  }

  return (
    <div className="relative pl-3 flex flex-col justify-center min-w-0">
      {/* Subtle edge glow */}
      <div 
        className="absolute left-0 top-0 bottom-0 w-[2px] rounded-full opacity-70"
        style={{ 
          background: `linear-gradient(to bottom, transparent, ${accentColor}, transparent)`,
          boxShadow: `0 0 10px ${accentColor}`
        }}
      />

      {/* 1. Topic Title */}
      {topicTitle && topicLink ? (
        <Link 
          to={topicLink} 
          className="text-[11px] font-bold text-white hover:text-[var(--tf-primary)] truncate transition-colors mb-1 uppercase tracking-wide block leading-tight"
          title={topicTitle}
        >
          {topicTitle}
        </Link>
      ) : topicTitle ? (
        <div className="text-[11px] font-bold text-white truncate mb-1 uppercase tracking-wide">
          {topicTitle}
        </div>
      ) : null}

      {/* 2. by [Avatar Frame] Username -> */}
      <div className="flex items-center gap-1.5 text-[11px] text-zinc-400 mb-0.5 flex-wrap">
        <span className="text-zinc-500">de</span>
        
        {/* Avatar with Frame inline in front of username */}
        <Link to={`/u/${u.username}`} className="inline-flex items-center shrink-0 relative hover:scale-110 transition-transform">
          <Avatar user={u} size={20} hover={true} />
        </Link>

        <Username 
          user={u} 
          className={`font-bold hover:text-white transition-colors uppercase ${u?.loadout?.username_style && u.loadout.username_style !== 'default' ? 'text-[12px]' : 'text-[11px]'}`} 
          style={{ color: u.group_color || accentColor }} 
        />

        {topicLink && (
          <Link to={topicLink} className="transition-colors hover:opacity-80">
            <ArrowRight className="w-3 h-3 stroke-[3]" style={{ color: accentColor }} />
          </Link>
        )}
      </div>

      {/* 3. Date */}
      <div className="text-[10px] text-zinc-500 font-medium font-mono flex items-center gap-1" title={formattedDate}>
        <Clock className="w-2.5 h-2.5 text-zinc-600" />
        <span>{relativeTime || formattedDate}</span>
      </div>

      {/* 4. Injected Stats */}
      {stats && (
        <div className="mt-1.5 pt-1 border-t border-white/5 relative z-20">
          {stats}
        </div>
      )}
    </div>
  );
}
